var map = {
	"../assignment-pvd/assignment-pvd.module": [
		"./src/app/modules/assignment-pvd/assignment-pvd.module.ts",
		"default~assignment-pvd-assignment-pvd-module~assignment-swh-assignment-swh-module~assignments-assign~85dd8634",
		"assignment-pvd-assignment-pvd-module"
	],
	"../assignment-swh/assignment-swh.module": [
		"./src/app/modules/assignment-swh/assignment-swh.module.ts",
		"default~assignment-pvd-assignment-pvd-module~assignment-swh-assignment-swh-module~assignments-assign~85dd8634",
		"assignment-swh-assignment-swh-module"
	],
	"../assignments/assignments.module": [
		"./src/app/modules/assignments/assignments.module.ts",
		"default~assignment-pvd-assignment-pvd-module~assignment-swh-assignment-swh-module~assignments-assign~85dd8634",
		"default~assignments-assignments-module~modules-admin-admin-module~modules-client-client-module"
	],
	"../control-centre/control-centre.module": [
		"./src/app/modules/control-centre/control-centre.module.ts",
		"default~assignment-pvd-assignment-pvd-module~assignment-swh-assignment-swh-module~assignments-assign~85dd8634",
		"default~control-centre-control-centre-module~modules-admin-admin-module",
		"control-centre-control-centre-module"
	],
	"../partner-inductions/partner-inductions.module": [
		"./src/app/modules/partner-inductions/partner-inductions.module.ts",
		"default~assignment-pvd-assignment-pvd-module~assignment-swh-assignment-swh-module~assignments-assign~85dd8634",
		"partner-inductions-partner-inductions-module"
	],
	"../people/people.module": [
		"./src/app/modules/people/people.module.ts",
		"default~assignment-pvd-assignment-pvd-module~assignment-swh-assignment-swh-module~assignments-assign~85dd8634",
		"default~modules-admin-admin-module~people-people-module"
	],
	"./modules/admin/admin.module": [
		"./src/app/modules/admin/admin.module.ts",
		"default~assignment-pvd-assignment-pvd-module~assignment-swh-assignment-swh-module~assignments-assign~85dd8634",
		"default~assignments-assignments-module~modules-admin-admin-module~modules-client-client-module",
		"default~control-centre-control-centre-module~modules-admin-admin-module",
		"default~modules-admin-admin-module~people-people-module",
		"modules-admin-admin-module"
	],
	"./modules/client/client.module": [
		"./src/app/modules/client/client.module.ts",
		"default~assignment-pvd-assignment-pvd-module~assignment-swh-assignment-swh-module~assignments-assign~85dd8634",
		"default~assignments-assignments-module~modules-admin-admin-module~modules-client-client-module",
		"modules-client-client-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;